import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import * as Yup from 'yup';
import { PropertyOwnerFirstNameRuleset } from '../../business/ruleset/solar_property';
import { RulesetResult } from '../../business/rules';
import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';

const {
  formField: { systemPropertyOwnerFirstName },
} = loanFormModel;

export class PropertyOwnerFirstNameValidation implements ValidationSchema {
  public name: string = systemPropertyOwnerFirstName.name;
  public label = systemPropertyOwnerFirstName.label;
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(schema: Yup.StringSchema, context: any) {
    if (!context.from) return schema;
    const application = context.from[1].value;
    const parent = context.parent;
    const index = application.principals.findIndex(
      (principal) =>
        principal.relationship == RELATED_PARTY_RELATIONSHIP.LANDLORD &&
        parent.id == principal.id
    );
    const result =
      PropertyOwnerFirstNameRuleset.setIndex(index).evaluate(application);

    if (result & RulesetResult.REQUIRED)
      return schema.required(systemPropertyOwnerFirstName.requiredErrorMsg);
    return schema;
  }
}
export default new Validation(new PropertyOwnerFirstNameValidation());
